import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions as transferActions } from "reducers/transfers";

export const useOtherFieldChange = (accounts, transferData, state) => {
    const dispatch = useDispatch();

    const handleDebitAccount = (debitAccountId, setFieldValue = null, values) => {
        const selected = accounts.find((_account) => _account.productId === debitAccountId);
        if (setFieldValue) {
            setFieldValue("amountField.currency", selected.currency);
        }
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                amountField: { ...values?.amountField, currency: selected?.currency },
                debitAccount: selected?.productId,
            }),
        );
    };

    const handleAccountType = (type, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                transferKind: type,
            }),
        );
    };

    const handleBeneficiary = (e, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                ...e,
            }),
        );
    };

    const handleConcept = (e, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                reasonCode: e,
            }),
        );
    };

    const handleChangeEmail = (e, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                email: e.target.value,
            }),
        );
    };

    const handleChangeMessage = (e, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                messageText: e.target.value,
            }),
        );
    };

    const handleOnChangeAmount = (amount, values) => {
        dispatch(
            transferActions.setOtherTransferData({
                ...values,
                amountField: {
                    ...amount.values.amountField,
                },
            }),
        );
    };

    useEffect(() => {
        if (!isEmpty(transferData)) {
            handleDebitAccount(transferData.debitAccount);
        }
        if (state?.accountId) {
            handleDebitAccount(state?.accountId);
        }
    }, []);

    return {
        handleDebitAccount,
        handleAccountType,
        handleBeneficiary,
        handleConcept,
        handleChangeEmail,
        handleChangeMessage,
        handleOnChangeAmount,
    };
};

export default useOtherFieldChange;
